module.exports = __webpack_public_path__ + "img/Left.b81e1eeb.svg";